import { gql } from '@apollo/client';

export const BRAND_IMAGES_FRAGMENT = gql`
  fragment BrandImages on BrandObject {
    id
    logo {
      url
      mimetype
      name
      size
    }
    favicon {
      url
      mimetype
      name
      size
    }
    backgroundImage {
      url
      mimetype
      name
      size
    }
  }
`;

export const BRAND_COLORS_FRAGMENT = gql`
  fragment BrandColors on BrandObject {
    id
    colors {
      topBarText
      topBar
      buttonText
      brand
      black
      alert
      accent
      headingFooter
      headingFooterText
    }
    defaultColors {
      topBarText
      topBar
      buttonText
      brand
      black
      alert
      accent
      headingFooter
      headingFooterText
    }
  }
`;
